<template>
  <div class="container">
    <div style="margin: 10px 10px 10px 10px;">
      <el-row>
        <el-col :span="6">
          <el-input placeholder="Search" v-model="filters[0].value"></el-input>
        </el-col>
      </el-row>
    </div>

    <data-tables
      :data="richmenuSettings"
      :pagination-props="{ pageSizes: [15, 25, 50] }"
      :filters="filters"
      :table-props="tableProps"
    >
      <el-table-column label="accountId" prop="accountId" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.accountId}}
        </template>
      </el-table-column>
      <el-table-column label="商店名稱" prop="name" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.name}}
          <input type="hidden" :id="'name'+'-'+scope.$index" :value="scope.row.name">
          <button @click="copy('name'+'-'+scope.$index)">複製</button>
        </template>
      </el-table-column>
      <el-table-column label="SI名稱" prop="name" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.siName}}
        </template>
      </el-table-column>
      <el-table-column label="點餐連結" prop="menuUrl" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.menuUrl}}
          <input type="hidden" :id="'menuUrl'+'-'+scope.$index" :value="scope.row.menuUrl">
          <button @click="copy('menuUrl'+'-'+scope.$index)">複製</button>
        </template>
      </el-table-column>
      <el-table-column label="訂單連結" prop="orderUrl" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.orderUrl}}
          <input type="hidden" :id="'orderUrl'+'-'+scope.$index" :value="scope.row.orderUrl">
          <button @click="copy('orderUrl'+'-'+scope.$index)">複製</button>
        </template>
      </el-table-column>
      <el-table-column label="營業資訊連結" prop="infoUrl" sortable="custom" min-width="30px">
        <template slot-scope="scope">{{scope.row.infoUrl}}
          <input type="hidden" :id="'infoUrl'+'-'+scope.$index" :value="scope.row.infoUrl">
          <button @click="copy('infoUrl'+'-'+scope.$index)">複製</button>
        </template>
      </el-table-column>
    </data-tables>

  </div>
</template>

<script>
import ElementUI from "element-ui";
import { fetchRichmenuSettings } from "src/javascripts/generalPages/fetchData";
import moment from "moment-timezone";
import axios from "axios";
var type;
var bType;
var siAccountId;
var id;
export default {
  beforeRouteEnter(to, from, next) {
    console.log("this.$route: ", to);
    let siName = to.query.name;
    fetchRichmenuSettings(siName)
      .then(res => {
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  created: function() {
    
  },
  data() {
    return {
      richmenuSettings: [],
      filters: [
        {
          prop: ["accountId", "name"],
          value: ""
        }
      ],
      tableProps: {
        
      }
    };
  },
  computed: {

  },
  methods: {
    setData: function(data) {
      console.log("data: ", data);
      this.richmenuSettings = data.map(d => {
        return {
          accountId: d.accountId,
          name: d.name,
          menuUrl: d.menuUrl,
          orderUrl: d.orderUrl,
          infoUrl: d.infoUrl,
          siName: d.siName,
        };
      });
    },
    copy(id) {
      console.log("id: ", id)
      let textToCopy = document.querySelector("#" + id);
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      textToCopy.setAttribute('type', 'hidden');
      if(successful){
        this.$message({
          type: 'success', message: `已複製`
        });
      } else {
        this.$message({
          type: 'warning', message: `錯誤`
        });
      }
    }
  },
  mounted() {
    
  },
  updated: function() {
   
  }
};
</script>